// extracted by mini-css-extract-plugin
module.exports = {"person":"ContactData_person__2lFOQ"};